/* thuisbatterijveilig.nl · Kap-thema v2 · interactie */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function nl(n, d) { return n.toFixed(d === undefined ? 1 : d).replace('.', ','); }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
    } catch (e) { return '€ ' + nl(cents / 100, 2); }
  }

  /* ---------- Scroll-reveal ---------- */
  function initReveal() {
    var items = $$('[data-reveal]');
    if (!document.documentElement.classList.contains('js-reveal') || reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
    /* Veiligheidsnet: na 2,5 s alles tonen dat nog verborgen is */
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-visible'); }); }, 2500);
  }

  /* ---------- Header-schaduw bij scrollen ---------- */
  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Aftelteller ---------- */
  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      var raw = el.getAttribute('data-countdown') || '2027-01-01T00:00';
      var target = new Date(raw.length <= 16 ? raw + ':00' : raw);
      if (isNaN(target)) return;
      var out = { d: el.querySelector('[data-cd="d"]'), h: el.querySelector('[data-cd="h"]'), m: el.querySelector('[data-cd="m"]'), s: el.querySelector('[data-cd="s"]') };
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = Math.max(0, target - new Date());
        var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
        if (out.d) out.d.textContent = d;
        if (out.h) out.h.textContent = pad(h);
        if (out.m) out.m.textContent = pad(m);
        if (out.s) out.s.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Een dag met je batterij ---------- */
  var SOLAR = [0,0,0,0,0,0,0.05,0.3,1.0,2.0,2.9,3.5,3.8,3.7,3.2,2.5,1.7,0.9,0.3,0.05,0,0,0,0];
  var USE = [0.3,0.25,0.25,0.25,0.25,0.3,0.5,0.9,0.7,0.5,0.5,0.6,0.7,0.5,0.5,0.6,0.8,1.4,1.8,1.6,1.2,1.0,0.7,0.4];

  function simulate(withBat, cap) {
    var soc = cap * 0.25, min = cap * 0.05, rows = [];
    for (var h = 0; h < 24; h++) {
      var s = SOLAR[h], u = USE[h], direct = Math.min(s, u), surplus = s - direct, deficit = u - direct, charge = 0, dis = 0;
      if (withBat) {
        charge = Math.min(surplus, cap - soc); soc += charge;
        dis = Math.max(0, Math.min(deficit, soc - min)); soc -= dis;
      }
      rows.push({ s: s, u: u, direct: direct, charge: charge, dis: dis, back: surplus - charge, buy: deficit - dis, soc: soc });
    }
    return rows;
  }

  function initEnergy() {
    $$('[data-energy]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var cap = parseFloat(root.getAttribute('data-capacity')) || 10;
      var data = { met: simulate(true, cap), zonder: simulate(false, cap) };
      var mode = 'met';
      var hour = root.querySelector('[data-hour]');
      var clock = root.querySelector('[data-clock]');
      var msg = root.querySelector('[data-msg]');
      var sun = root.querySelector('[data-sun]');
      var socEl = root.querySelector('[data-soc]');
      var bars = root.querySelector('[data-bars]');
      var play = root.querySelector('[data-play]');
      var maxv = 4;

      for (var h = 0; h < 24; h++) {
        var top = Math.max(SOLAR[h], USE[h]);
        var sp = document.createElement('span');
        sp.style.height = (top / maxv * 100) + '%';
        sp.title = (h < 10 ? '0' : '') + h + ':00';
        var i = document.createElement('i');
        i.style.height = (SOLAR[h] / Math.max(top, 0.01) * 100) + '%';
        sp.appendChild(i);
        (function (hh) { sp.addEventListener('click', function () { hour.value = hh; render(); }); })(h);
        bars.appendChild(sp);
      }

      function flow(name, v) { var el = root.querySelector('[data-flow="' + name + '"]'); if (el) el.classList.toggle('on', v > 0.04); }
      function stat(name, v) { var el = root.querySelector('[data-stat="' + name + '"]'); if (el) el.textContent = v; }

      function render() {
        var h = +hour.value, r = data[mode][h];
        clock.textContent = (h < 10 ? '0' : '') + h + ':00';
        var t = Math.min(Math.max((h - 6) / 14, 0), 1), ang = Math.PI * (1 - t);
        sun.setAttribute('cx', (320 + 280 * Math.cos(ang)).toFixed(1));
        sun.setAttribute('cy', (190 - 207 * Math.sin(ang)).toFixed(1));
        sun.style.opacity = (h >= 6 && h <= 20) ? 1 : 0.15;
        flow('direct', r.direct); flow('charge', r.charge); flow('dis', r.dis); flow('back', r.back); flow('buy', r.buy);
        var pct = mode === 'met' ? r.soc / cap : 0, hg = 26 * pct;
        socEl.setAttribute('height', hg.toFixed(1)); socEl.setAttribute('y', (197 - hg + 1).toFixed(1));
        $$('span', bars).forEach(function (sp, i) { sp.classList.toggle('cur', i === h); });
        var m;
        if (r.charge > 0.04) m = 'De zon levert ' + nl(r.s) + ' kW. Je huis gebruikt ' + nl(r.u) + ' kW; de rest (' + nl(r.charge) + ' kW) gaat je batterij in.';
        else if (r.dis > 0.04) m = 'Weinig of geen zon. Je huis gebruikt ' + nl(r.u) + ' kW, en ' + nl(r.dis) + ' kW daarvan komt uit je eigen batterij.';
        else if (r.back > 0.04) m = (mode === 'met' ? 'Je batterij is vol. ' : 'Zonder batterij: ') + nl(r.back) + ' kW gaat terug naar het net, voor een lage vergoeding na 2027.';
        else if (r.buy > 0.04) m = 'Je koopt ' + nl(r.buy) + ' kW in van het net' + (mode === 'met' ? ', want je batterij is leeg.' : '.');
        else m = 'Je huis draait op je eigen zonnestroom.';
        msg.textContent = m;
        var tot = data[mode].reduce(function (a, x) { a.s += x.s; a.own += x.direct + x.dis; a.back += x.back; a.buy += x.buy; return a; }, { s: 0, own: 0, back: 0, buy: 0 });
        stat('self', Math.round(tot.own / tot.s * 100) + '%');
        stat('back', nl(tot.back) + ' kWh');
        stat('buy', nl(tot.buy) + ' kWh');
        stat('soc', mode === 'met' ? Math.round(pct * 100) + '%' : '–');
      }

      hour.addEventListener('input', render);
      $$('.seg button', root).forEach(function (b) {
        b.addEventListener('click', function () {
          mode = b.getAttribute('data-mode');
          $$('.seg button', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          render();
        });
      });

      var timer = null;
      function stop() { if (timer) { clearInterval(timer); timer = null; } play.textContent = '▶ Speel de dag'; }
      play.addEventListener('click', function () {
        if (timer) { stop(); return; }
        play.textContent = '❚❚ Pauze';
        timer = setInterval(function () { hour.value = (+hour.value + 1) % 24; render(); }, reduceMotion ? 1400 : 750);
      });
      hour.addEventListener('pointerdown', stop);

      /* Eenmalig automatisch afspelen van 6:00 tot 20:00 zodra het in beeld komt */
      if (!reduceMotion && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          hour.value = 6; render();
          var n = 0;
          timer = setInterval(function () {
            hour.value = +hour.value + 1; render();
            if (++n >= 14) stop();
          }, 600);
          play.textContent = '❚❚ Pauze';
        }, { threshold: 0.4 });
        io.observe(root);
      }
      render();
    });
  }

  /* ---------- Verken de Batteryshelter ---------- */
  function initExplorer() {
    $$('[data-explorer]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var tabs = $$('[data-tab]', root), panels = $$('[data-tabpanel]', root);
      function selectTab(i) {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', i === j ? 'true' : 'false'); t.tabIndex = i === j ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { selectTab(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            selectTab(n); tabs[n].focus();
          }
        });
      });

      var spots = $$('[data-hotspot]', root), items = $$('[data-hotspot-item]', root), current = 0;
      function show(i) {
        current = (i + spots.length) % spots.length;
        spots.forEach(function (s, j) { s.classList.toggle('is-active', j === current); s.setAttribute('aria-pressed', j === current ? 'true' : 'false'); });
        items.forEach(function (it, j) { it.classList.toggle('is-active', j === current); });
      }
      spots.forEach(function (s, i) { s.addEventListener('click', function () { root.classList.add('was-used'); show(i); }); });
      var prev = root.querySelector('[data-hotspot-prev]'), next = root.querySelector('[data-hotspot-next]');
      if (prev) prev.addEventListener('click', function () { root.classList.add('was-used'); show(current - 1); });
      if (next) next.addEventListener('click', function () { root.classList.add('was-used'); show(current + 1); });
    });
  }

  /* ---------- Stappenplan ---------- */
  function initSteps() {
    $$('[data-steps]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var tabs = $$('[data-step-tab]', root), panels = $$('[data-step-panel]', root), bar = root.querySelector('[data-step-bar]');
      function select(i) {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', i === j ? 'true' : 'false'); t.tabIndex = i === j ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
        if (bar) bar.style.width = ((i + 1) / tabs.length * 100) + '%';
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(n); tabs[n].focus();
          }
        });
      });
      select(0);
    });
  }

  /* ---------- Reviews-slider ---------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (slider) {
      if (slider.dataset.ready) return; slider.dataset.ready = '1';
      var section = slider.closest('section');
      var step = function () { var c = slider.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; };
      var p = section.querySelector('[data-slide-prev]'), n = section.querySelector('[data-slide-next]');
      if (p) p.addEventListener('click', function () { slider.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { slider.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Productpagina: varianten ---------- */
  function initProduct() {
    $$('[data-product-section]').forEach(function (section) {
      var jsonEl = section.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var idInput = section.querySelector('[data-variant-id]');
      var addBtn = section.querySelector('[data-add-button]');
      var addLabel = section.querySelector('[data-add-label]');
      var priceEl = section.querySelector('[data-price]');
      var stockEl = section.querySelector('[data-stock]');
      var mainImg = section.querySelector('[data-main-media] img');

      function selectedOptions() {
        return $$('.variant-picker__group', section).map(function (group) {
          var checked = group.querySelector('input:checked');
          var label = group.querySelector('[data-option-label]');
          if (checked && label) label.textContent = checked.value;
          return checked ? checked.value : null;
        });
      }
      function update() {
        var opts = selectedOptions();
        var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
        if (!variant) { if (addBtn) addBtn.disabled = true; if (addLabel) addLabel.textContent = 'Niet beschikbaar'; return; }
        if (idInput) idInput.value = variant.id;
        if (addBtn) addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? 'In winkelwagen' : 'Tijdelijk uitverkocht';
        if (stockEl) stockEl.textContent = variant.available ? '✓ Op voorraad' : 'Niet op voorraad';
        if (priceEl && !section.hasAttribute('data-binnenkort')) {
          priceEl.innerHTML = variant.price === 0
            ? '<span class="price__value">Prijs op aanvraag</span>'
            : '<span class="price__value">' + formatMoney(variant.price) + '</span>' +
              (variant.compare_at_price > variant.price ? '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' : '') +
              '<span class="price__tax">incl. btw</span>';
        }
        if (mainImg && variant.featured_image && variant.featured_image.src) { mainImg.removeAttribute('srcset'); mainImg.src = variant.featured_image.src; }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      $$('[data-option-input]', section).forEach(function (input) { input.addEventListener('change', update); });
      $$('[data-thumb]', section).forEach(function (btn) {
        btn.addEventListener('click', function () { if (!mainImg) return; mainImg.removeAttribute('srcset'); mainImg.src = btn.getAttribute('data-src'); });
      });
    });
  }

  /* ---------- Overig ---------- */
  function initMisc() {
    $$('.qty').forEach(function (qty) {
      var input = qty.querySelector('input'), minus = qty.querySelector('[data-qty-minus]'), plus = qty.querySelector('[data-qty-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 0) + 1; });
    });
    $$('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value); url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
    $$('[data-menu-drawer]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        var header = d.closest('.site-header');
        if (d.open && header) document.documentElement.style.setProperty('--drawer-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
        document.documentElement.classList.toggle('menu-open', d.open);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('[data-menu-drawer][open]').forEach(function (d) { d.removeAttribute('open'); });
    });
  }

  /* ---------- v3: Binnen of buiten ---------- */
  function initInsideOutside() {
    $$('[data-io]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var ba = root.querySelector('[data-ba]'), range = root.querySelector('[data-ba-range]');
      if (ba && range) {
        range.addEventListener('input', function () { ba.style.setProperty('--x', range.value + '%'); root.classList.add('was-used'); });
        /* Eenmalige demo-beweging zodat bezoekers zien dat het schuift */
        if (!reduceMotion && 'IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (en) {
            if (!en[0].isIntersecting) return; io.disconnect();
            var t0 = null;
            function step(ts) {
              if (root.classList.contains('was-used')) return;
              if (!t0) t0 = ts; var p = (ts - t0) / 1800;
              var v = 50 + Math.sin(p * Math.PI * 2) * 22 * (1 - Math.min(p, 1));
              ba.style.setProperty('--x', v + '%'); range.value = v;
              if (p < 1) requestAnimationFrame(step); else { ba.style.setProperty('--x', '50%'); range.value = 50; }
            }
            requestAnimationFrame(step);
          }, { threshold: 0.5 });
          io.observe(ba);
        }
      }
      var tabs = $$('[data-io-tab]', root), panels = $$('[data-io-panel]', root);
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x, j) { x.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
          panels.forEach(function (p, j) { p.hidden = i !== j; });
        });
      });
    });
  }

  /* ---------- v3: Generieke tabs (maatkiezer) ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var btns = $$('[data-tab-btn]', root), panels = $$('[data-tab-panel]', root);
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          btns.forEach(function (x, j) { x.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
          panels.forEach(function (p, j) { p.hidden = i !== j; });
        });
      });
    });
  }

  /* ---------- v3: Kleurkiezer ---------- */
  function initColors() {
    $$('[data-colors]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var btns = $$('[data-color-btn]', root), imgs = $$('[data-color-img]', root), texts = $$('[data-color-text]', root);
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          btns.forEach(function (x, j) { x.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
          imgs.forEach(function (x, j) { x.classList.toggle('is-on', i === j); });
          texts.forEach(function (x, j) { x.hidden = i !== j; });
        });
      });
    });
  }

  /* ---------- v3: Hotspots: lijst-knoppen koppelen ---------- */
  function initSpotJumps() {
    $$('[data-hotspot-jump]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = '1';
      b.addEventListener('click', function () {
        var root = b.closest('[data-explorer]'); if (!root) return;
        var spot = root.querySelector('[data-hotspot="' + b.getAttribute('data-hotspot-jump') + '"]');
        if (spot) spot.click();
      });
    });
  }

  /* ---------- v3: Seizoenen op touch openklikken ---------- */
  function initSeasons() {
    $$('.season').forEach(function (s) {
      if (s.dataset.ready) return; s.dataset.ready = '1';
      s.addEventListener('click', function () { s.classList.toggle('is-open'); });
    });
  }

  /* ---------- v3: Montage in stappen ---------- */
  function initBuild() {
    $$('[data-build]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var steps = $$('[data-build-step]', root), stage = root.querySelector('.build__stage'), count = root.querySelector('[data-build-count]'), cur = 0;
      function show(i) {
        cur = (i + steps.length) % steps.length;
        steps.forEach(function (s, j) { s.setAttribute('aria-selected', j === cur ? 'true' : 'false'); });
        var s = steps[cur];
        if (stage) { stage.style.setProperty('--fx', (s.getAttribute('data-focus') || 50) + '%'); stage.style.setProperty('--fz', (parseFloat(s.getAttribute('data-zoom')) || 100) / 100); }
        if (count) count.textContent = (cur + 1) + ' / ' + steps.length;
      }
      steps.forEach(function (s, i) { s.addEventListener('click', function () { show(i); }); });
      var prev = root.querySelector('[data-build-prev]'), next = root.querySelector('[data-build-next]');
      if (prev) prev.addEventListener('click', function () { show(cur - 1); });
      if (next) next.addEventListener('click', function () { show(cur + 1); });
      show(0);
    });
  }

  /* ---------- v3: Video met poster ---------- */
  function initVideo() {
    $$('[data-video]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var btn = root.querySelector('[data-video-play]'), vid = root.querySelector('video');
      if (!btn) return;
      if (!vid) { btn.disabled = true; return; }
      btn.addEventListener('click', function () {
        root.classList.add('is-playing');
        vid.setAttribute('controls', 'controls');
        var p = vid.play(); if (p && p.catch) p.catch(function () {});
      });
    });
  }

  /* ---------- v3: Galerij-filter + lightbox ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (grid) {
      if (grid.dataset.ready) return; grid.dataset.ready = '1';
      var section = grid.closest('section');
      var items = $$('.gallery__item', grid);
      $$('[data-filter]', section).forEach(function (f) {
        f.addEventListener('click', function () {
          var tag = f.getAttribute('data-filter');
          $$('[data-filter]', section).forEach(function (x) { x.setAttribute('aria-pressed', x === f ? 'true' : 'false'); });
          items.forEach(function (it) { it.classList.toggle('is-hidden', tag !== '*' && it.getAttribute('data-tag') !== tag); });
        });
      });
      var dlg = section.querySelector('[data-lightbox-dialog]');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var img = dlg.querySelector('[data-lightbox-img]'), cap = dlg.querySelector('[data-lightbox-cap]'), idx = 0;
      function visible() { return items.filter(function (it) { return !it.classList.contains('is-hidden'); }); }
      function open(i) {
        var list = visible(); if (!list.length) return;
        idx = (i + list.length) % list.length;
        var b = list[idx].querySelector('[data-lightbox]');
        img.src = b.getAttribute('data-lightbox'); img.alt = b.getAttribute('data-caption') || ''; cap.textContent = b.getAttribute('data-caption') || '';
        if (!dlg.open) dlg.showModal();
      }
      items.forEach(function (it) {
        var b = it.querySelector('[data-lightbox]');
        b.addEventListener('click', function () { open(visible().indexOf(it)); });
      });
      dlg.querySelector('[data-lightbox-close]').addEventListener('click', function () { dlg.close(); });
      dlg.querySelector('[data-lightbox-prev]').addEventListener('click', function () { open(idx - 1); });
      dlg.querySelector('[data-lightbox-next]').addEventListener('click', function () { open(idx + 1); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') open(idx - 1); if (e.key === 'ArrowRight') open(idx + 1); });
    });
  }

  function init() {
    initReveal(); initHeader(); initCountdown(); initEnergy(); initExplorer(); initSteps(); initSliders(); initProduct(); initMisc();
    initInsideOutside(); initTabs(); initColors(); initSpotJumps(); initSeasons(); initBuild(); initVideo(); initGallery();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () {
    initReveal(); initCountdown(); initEnergy(); initExplorer(); initSteps(); initSliders();
    initInsideOutside(); initTabs(); initColors(); initSpotJumps(); initSeasons(); initBuild(); initVideo(); initGallery();
  });
})();
